





























import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import AgencyUsers from '@/components/AgencyUsers/AgencyUsers.vue'
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'
import PageNames from '@/router/PageNames';


@Component({
	name: 'AgencyUserSettings',
  	components: { AgencyUsers, Alert }
})
export default class extends GiganautVue {

	beforeMount() {
		AgencySettingsModule.getAgencyUsers();
		AgencySettingsModule.getBranches();
  	}

	navigateToAgencySettings() {
		this.$router.push({ name: PageNames.AgencySettings });
	}

  	get loading() {
		return AgencySettingsModule.loadingAgencyUsers;
  	}
}
